export const globalSearch = () => ({
    search: (query: string) => `/search/${query}`,
    collectionSearch: (query: string) => `/collections/search/${query}`,
    collectionsBySlug: (query: string) => `/collections/slugs/${query}`,
});
